import React from 'react';
import AddressLines from '../Common/AddressLines';
import { Loader } from 'lucide-react';
import { Euro, Infdoor, Outdoor, Walk, Bus } from '../Icons/CustomIcons';

const COST_LEVEL = {
  free:   0,
  low:    1,
  medium: 2,
  high:   3,
};

const CostIndicator = ({ costRange }) => {
  const activeCount = COST_LEVEL[costRange] ?? 0;
  return (
    <div className="cost-indicator">
      {[0, 1, 2].map((index) => {
        const isActive = index >= (3 - activeCount);
        return (
          <Euro
            key={index}
            className={`cost-icon cost-icon--${index} ${isActive ? 'cost-icon--active' : ''}`}
            coinColor={isActive ? 'var(--Colors-Accent-01)' : 'var(--Colors-Grey-02)'}
            textColor={'var(--Colors-White)'}
          />
        );
      })}
    </div>
  );
};

function getCostLabel(costRange) {
  const map = {
    free:   'Gratis',
    low:    '0–10 CHF',
    medium: '10–30 CHF',
    high:   '30+ CHF',
  };
  return map[costRange] || costRange;
}

function CostIndicatorDisplay({ costRange }) {
  return (
    <button className="body Font-S-B-130-T tag tag--properties">
      <span className="tag--icon"><CostIndicator costRange={costRange}/></span>
      {getCostLabel(costRange)}
    </button>
  );
}

function IndoorOutdoorDisplay({ type }) {
  const label = { indoor: 'Drinnen', outdoor: 'Draussen', both: 'Beides' }[type] || type;
  const Icon = type === 'outdoor' ? Outdoor : Infdoor;
  return (
    <button className="body Font-S-B-130-T tag tag--properties">
      <span className="tag__icon"><Icon color="var(--Colors-Accent-01)" /></span>
      {label}
    </button>
  );
}

export function ActivityTopSection({ activity }) {
  return (
    <div className="ac-meta-row">
      <span className="body Font-M-A-130-T tag tag--age">
        {activity.age_min}–{activity.age_max} Jahre
      </span>
      <span className="ac-divider" />
      <CostIndicatorDisplay costRange={activity.cost_range} />
      <span className="ac-divider" />
      <IndoorOutdoorDisplay type={activity.indoor_outdoor} />
    </div>
  );
}

export function ActivityCategoryList({ categories, className, chipClassName, style }) {
  const cats = Array.isArray(categories) ? categories : [];
  if (cats.length === 0) return null;
  return (
    <div className={className} style={style}>
      {cats.map((cat) => (
        <span key={typeof cat === 'string' ? cat : cat.id} className={chipClassName}>
          {typeof cat === 'string' ? cat : cat.name}
        </span>
      ))}
    </div>
  );
}

export function TravelTimeDisplay({ travelLoading, travelError, travelTime, atDestination = false }) {
  return (
    <div className="travel">
      <div className="travel-icon">
        {travelLoading ? (
          <Loader size={20} className="travel-loading" />
        ) : (atDestination || (travelTime != null && travelTime <= 20)) ? (
          <Walk size={20} color="#fff" />
        ) : (
          <Bus size={20} color="#fff" />
        )}
      </div>
      <span className="body-s line-height-default letter-spacing-tight Colors-Black">
        {travelLoading ? (
          '…'
        ) : atDestination ? (
          <span className="body--semibold">Sie sind am Ziel</span>
        ) : travelError ? (
          '—'
        ) : travelTime != null ? (
          <><span className="body--semibold">{travelTime} min</span> (von Ihnen entfernt)</>
        ) : (
          '— min'
        )}
      </span>
    </div>
  );
}

export const LocationAddress = ({ locationName, address, street, plz, city }) => (
  <div className="ac-address">
    <span className="body Font-L-S-130-T">{locationName}</span>
    {locationName && (
      <AddressLines
        address={address}
        street={street}
        plz={plz}
        city={city}
        className="body Font-S-B-130-T Colors-Black"
      />
    )}
  </div>
);
